import React from 'react'

const Driverdashboard = () => {
  return (
    <div>
      this is driver dashboard page
    </div>
  )
}

export default Driverdashboard
